/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { defineMessages } from 'react-intl';

import { I18NError } from 'Utils';
import { fetchGet } from 'FetchAPIs';

const messages = defineMessages({
  errorGettingPlatformData: 'Unable to retrieve data. {message}',
});

export function getPlatformConnectionInfo() {
  return fetchGet(`/api/tenants/iotp-info`)
    .then(response => response)
    .catch(error => {
      throw new I18NError(messages.errorGettingPlatformData, error.response);
    });
}
